import { AnyProviderWithScribe, Role } from '../../../../shared/common/auth/RoleAuth';

// SECURITY REVIEW REQUIRED (SCRUM-801): roles allowed to launch the embedded ScriptSure
// e-prescribing session.  Mirrors the backend launch endpoint's claim set: PostAcuteAdmin,
// ClinicalCoordinator, and AnyProviderWithScribe (Physician*, AdvancedPracticePractitioner*,
// PhysicianScribe) — the same set as the implantable-devices route.  Owned here so the route
// gate (routes.tsx) and the chart entry button can never drift apart.
// SYSADMIN is explicit because the route (AuthorizedRoute) and backend already imply it —
// without it the entry button would hide from an admin who can reach the page anyway.
export const erxLaunchRoles: Role[] = [Role.SYSADMIN, Role.POST_ACUTE_ADMIN, Role.CLINICAL_COORDINATOR, ...AnyProviderWithScribe];
